import { useEffect } from 'react';
import { isServerError, useAxios } from 'src/hooks/use-axios';
import { TradeProposalsParams } from 'src/pages/reporting/secondary-tradings/overview/trade-proposals/use-trade-proposals-params';
import { TradeProposals } from 'src/pages/reporting/secondary-tradings/overview/types';

export type TradeProposalsHookParams = Partial<
  TradeProposalsParams & {
    proposalType?: 'PROPOSAL_TO_SELL' | 'PROPOSAL_TO_BUY';
    networkPoint?: string;
  }
>;

type Options = {
  params: TradeProposalsHookParams;
};

export function useTradeProposals({ params }: Options) {
  const proposals = useAxios(
    (axios, signal, params: TradeProposalsHookParams) =>
      axios.request<TradeProposals>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/proposal`,
        method: 'GET',
        params,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        if (isServerError(error) && error.response.status === 404) {
          // this happens if we search for a non-existing response id
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  useEffect(() => {
    proposals.execute(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return proposals;
}

export type TradeProposalsRequest = ReturnType<typeof useTradeProposals>;
